import React, { useEffect, useState } from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
  Menu,
  IconButton,
  Button,
  TextField,
  Stack,
  Autocomplete,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCityFilter,
  setStateFilter,
} from '../../containers/app-container/reducer/filterSlice';
import yourhandle from 'countrycitystatejson';

const FilterState = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [states, setStates] = useState([]);

  const dispatch = useDispatch();
  const selectedCountry = useSelector((state) => state.filter.country);
  const appliedCity = useSelector((state) => state.filter.city);
  const appliedState = useSelector((state) => state.filter.state);

  // Local (temporary) selections before applying
  const [tempState, setTempState] = useState('');
  const [tempCity, setTempCity] = useState('');

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleApply = () => {
    dispatch(setStateFilter({ state: tempState || '' }));
    dispatch(setCityFilter({ city: tempCity || '' }));
    handleClose();
  };

  const handleReset = () => {
    setTempState('');
    setTempCity('');
    setCityOptions([]);
    dispatch(setStateFilter({ state: '' }));
    dispatch(setCityFilter({ city: '' }));
  };

  useEffect(() => {
    if (selectedCountry) {
      setStates(yourhandle.getStatesByShort(selectedCountry?.code));
    } else {
      setStates([]);
      setCityOptions([]);
      setTempCity('');
      setTempState('');
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (tempState && selectedCountry) {
      setCityOptions(yourhandle.getCities(selectedCountry?.code, tempState));
    } else {
      setCityOptions([]);
    }
  }, [selectedCountry, tempState]);

  useEffect(() => {
    // Sync temp values with applied ones when filter opens
    if (anchorEl) {
      setTempState(appliedState || '');
      setTempCity(appliedCity || '');
    }
  }, [anchorEl]);

  return (
    <div>
      <IconButton onClick={handleClick}>
        <FilterListIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '20px',
            padding: '20px',
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div>
          <Button
            className="d-block w-100 bg-none shadow-none text-warning-900 fw-medium mb-16 ps-0"
            sx={{ textTransform: 'capitalize' }}
            onClick={handleReset}
          >
            Reset
          </Button>
        </div>

        <Stack spacing={2} sx={{ width: 300 }}>
          <label>State</label>
          <Autocomplete
            id="state-autocomplete"
            options={states}
            value={tempState}
            onChange={(e, newValue) => {
              setTempState(newValue || '');
              setTempCity('');
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select State"
                sx={{
                  '& .MuiInputBase-root': { height: '40px', background: 'var(--white) !important' },
                  '& .MuiOutlinedInput-notchedOutline': { borderRadius: '8px' },
                }}
              />
            )}
          />

          <label>City</label>
          <Autocomplete
            id="city-autocomplete"
            options={cityOptions}
            value={tempCity}
            onChange={(e, newValue) => setTempCity(newValue || '')}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select City"
                sx={{
                  '& .MuiInputBase-root': { height: '40px', background: 'var(--white) !important' },
                  '& .MuiOutlinedInput-notchedOutline': { borderRadius: '8px' },
                }}
              />
            )}
            disabled={!tempState}
          />
        </Stack>

        <div>
          <Button
            className="d-block w-100 text-center text-md fw-medium bg-warning-900 px-20 py-9 radius-8 text-white mt-16"
            onClick={handleApply}
            variant="contained"
          >
            Apply
          </Button>
        </div>
      </Menu>
    </div>
  );
};

export default FilterState;
